module.exports = __webpack_public_path__ + "static/media/Glameow_gaussian2.d1a4b381.png";